<template>
  <rpm-button-dynamic-tag
    class="
      inline-flex justify-center items-center relative
      overflow-hidden transition-all duration-150
    "
    :class="[
      !invert ? 'flex-row':'flex-row-reverse',
      label ? [padding, 'rounded-lg']:'',
      getColor(),
      getText()
    ]"
    v-tooltip.top="{
      value: tooltipText,
      autoHide: false,
      pt: {
        text: 'font-semibold tracking-wider bg-gray-600 px-2 py-1 text-xs'
      }
    }"
    :disabled="disabled"
  >

    <div v-if="validSlot('default') && !loading">
      <slot></slot>
    </div>

    <span
      v-if="label && !loading"
      class="uppercase"
      v-html="label"
    ></span>

    <i v-show="icon && !loading" :class="icon"></i>

    <rpm-spinner
      v-if="loading"
      :size="label ? 'h-6 w-6':'h-4 w-4'"
      :border="label ? 'border-4':'border-3'"
    ></rpm-spinner>

  </rpm-button-dynamic-tag>
</template>

<script>

  import RpmButtonDynamicTag from "./RpmButtonDynamicTag.vue";
  import RpmSpinner from "#components/RpmSpinner.vue";

  export default {
    name: "RpmButton",
    components: {
      RpmButtonDynamicTag,
      RpmSpinner
    },
    props: {
      icon: {
        type: String,
        default: ""
      },
      label: {
        type: String,
        default: ""
      },
      tooltipText: {
        type: String,
        default: ""
      },
      color: {
        type: String,
        default: "theme"
      },
      colorClass: {
        type: String,
        default: ""
      },
      padding: {
        type: String,
        default: "px-4 py-2"
      },
      fontClass: {
        type: String,
        default: ""
      },
      noBorder: {
        type: Boolean,
        default: false
      },
      noHover: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      invert: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        hoverBase: "hover:ring hover:ring-offset-2 hover:ring-offset-white dark:hover:ring-offset-slate-900"
      }
    },
    methods: {
      getColor(){
        if(this.colorClass){
          return this.colorClass;
        }else{
          switch (this.color) {
            case "transparent":
              return "hover:text-theme text-default dark:text-white";
            case "red-hover":
              return "hover:text-red-600 focus:text-red-7q00 text-red-500";
            case "gray":
              return [
                "bg-gray-600 text-white",
                !this.noBorder ? "border border-gray-600":"",
                !this.noHover ? [
                  this.hoverBase,
                  "hover:ring-gray-600/30"
                ]:""
              ];
            case "red":
              return [
                "bg-red-500 text-white",
                !this.noBorder ? "border border-red-600":"",
                !this.noHover ? [
                  this.hoverBase,
                  "hover:ring-red-600/30"
                ]:""
              ];
            case "theme":
            default:
              return [
                "bg-theme text-white",
                !this.noBorder ? "border border-theme":"",
                !this.noHover ? [
                  this.hoverBase,
                  "hover:ring-theme/30"
                ]:""
              ];
          }
        }
      },
      getText(){
        if(!this.fontClass){
          if(this.icon && !this.label) return "text-md font-bold";
          return "text-xxs font-bold";
        } return this.fontClass;
      },
      validSlot(slot) {
        return !!this.$slots[slot];
      }
    },
  };
</script>
